import Router from 'vue-router'
import Root from '../Root.vue'
import NotFoundPage from '../components/views/404Page.vue'
import PlatMapPreview from '../components/views/PlatMapPreview.vue'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:areaName/:cityStateName/:communityName/plat',
      component: Root,
    },
    {
      path: '/sales-plat/preview',
      component: PlatMapPreview,
    },
    {
      path: '*',
      component: NotFoundPage,
    },
  ],
});

export default router;